export const COPY_INTERACTION_TIME = 1000;
export const INTERACTION_TIME = 1000;

export const PermissionsEnum = {
  USER_ADD: "USER_ADD",
  USER_EDIT: "USER_EDIT",
  USER_DELETE: "USER_DELETE",
  SETTINGS_IDEAS: "SETTINGS_IDEAS",
  SETTINGS_ROLES: "SETTINGS_ROLES",
  SETTINGS_GROUPS: "SETTINGS_GROUPS",
  DATASTORE_CREATE: "DATASTORE_CREATE",
  DATASTORE_EDIT: "DATASTORE_EDIT",
  SECURITY_VIEW: "SECURITY_VIEW",
  USER_ROLE_EDIT: "USER_ROLE_EDIT",
};

export const RolesEnum = {
  OWNER: "Owner",
  ADMIN: "Admin",
  USER: "User",
};

export const TIME_PERIODS = [
  {
    label: "Last Day",
    period: 1,
  },
  {
    label: "Last Week",
    period: 7,
  },
  {
    label: "Last Month",
    period: 30,
  },
  {
    label: "Last 3 Months",
    period: 90,
  },
  {
    label: "Last 6 Months",
    period: 180,
  },
];

export const SSOProvider = {
  OKTA: "okta",
  // Add more providers here as needed
};

// Utility function to check if a string is a valid SSO provider
export const isValidSSOProvider = (provider: string): boolean => {
  return Object.values(SSOProvider).includes(provider);
};

// Privacy levels
export const Privacy = {
  PRIVATE: "private",
  PUBLIC: "public",
};

// Screen breakpoints
export const SMALL_SCREEN_BREAKPOINT = 1440;
export const MOBILE_SCREEN_BREAKPOINT = 768;

export const DATABRICKS_STATUS_COLORS = {
  success: "#4CAF50",
  error: "#F44336",
  warning: "#FF9800",
} as const;
